
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/[id]/[page_id]",
      function () {
        return require("private-next-pages/books/[id]/[page_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/[id]/[page_id]"])
      });
    }
  